<template>
  <div
    class="text-align-left pj_clearfix"
    v-if="this.$store.get('systems@ApiKey')"
  >
    <b-alert show variant="dark">
      <b-alert show variant="secondary">
        <div v-if="!this.tbTableData">
          <b-badge variant="warning" class="font18px"
            >ไม่พบรายการที่ค้นหา !</b-badge
          >
        </div>
        <div>
          <b-table
            striped
            hover
            small
            :items="this.tbTableData"
            :fields="this.tbTableFieldsData"
            :sort-by.sync="sortBy"
            :sort-asc.sync="sortDesc"
            class="font13px"
            responsive
          >
            <template v-slot:cell(viewFiles)="row">
              <div
                style="width:22px;margin:auto;"
                @click="
                  viewDocScans(
                    row.item.hn,
                    row.item.scan_opd_card_type,
                    row.item.scan_opd_card_datetime,
                    row.item.scan_opd_card_file_name
                  )
                "
              >
                <v-icon
                  name="file"
                  class="icon-custom1 cursor-pointer font-color2"
                ></v-icon>
              </div>
            </template>
            <template v-slot:cell(deleteFiles)="row">
              <div style="width:22px;margin:auto;">
                <div
                  v-if="row.item.deleteFiles != 'Y'"
                  @click="
                    DeleteFilesScanConfirm(
                      'ยืนยันการลบไฟล์ !',
                      row.item.hn,
                      row.item.scan_opd_card_datetime,
                      row.item.scan_opd_card_type,
                      row.item.scan_opd_card_file_name,
                      'Y'
                    )
                  "
                >
                  <v-icon
                    name="trash-2"
                    class="icon-custom1 cursor-pointer font-color2"
                  ></v-icon>
                </div>
                <div
                  v-if="
                    row.item.deleteFiles == 'Y' &&
                      row.item.scan_file_delete_forever_status != 'Y'
                  "
                  @click="
                    DeleteFilesScanConfirm(
                      'ยืนยันการกู้คืนไฟล์ !',
                      row.item.hn,
                      row.item.scan_opd_card_datetime,
                      row.item.scan_opd_card_type,
                      row.item.scan_opd_card_file_name,
                      'N'
                    )
                  "
                >
                  <v-icon
                    name="trash-2"
                    class="icon-custom1 cursor-pointer font-color-color4"
                    v-b-tooltip.hover="
                      'Delete Log. ' +
                        row.item.scan_file_delete_user +
                        ' | ' +
                        thaiDatetimeFc.ThaiDateTime(
                          row.item.scan_file_delete_datetime
                        )
                    "
                  ></v-icon>
                </div>
                <div
                  v-if="
                    row.item.deleteFiles != '' &&
                      row.item.scan_file_delete_forever_status == 'Y'
                  "
                >
                  <v-icon
                    name="trash-2"
                    class="icon-custom1 cursor-pointer font-color2"
                    v-b-tooltip.hover="
                      'Delete Log. ' +
                        thaiDatetimeFc.ThaiDateTime(
                          row.item.scan_file_delete_forever_datetime
                        )
                    "
                  ></v-icon>
                </div>
              </div>
            </template>
          </b-table>
        </div>
      </b-alert>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import feather from "vue-icon";
import store from "@/store/store";
import axios from "axios";
import thaiDatetime from "@/functions/thaiDatetime";
import pjFunctions from "@/functions/pjFunctions";

@Component({
  props: ["MyScanDate", "MyHn", "MyScanType", "MySearchStatus"],
  component: {
    store,
    axios,
    thaiDatetime,
    pjFunctions
  },
  data() {
    return {
      thaiDatetimeFc: null,
      pjFunctionsFc: null,
      lang: {
        // days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        days: ["อา", "จ", "อ", "พ", "พฤ", "ศ", "ส"],
        months: [
          "ม.ค",
          "ก.พ",
          "มี.ค",
          "เม.ย",
          "พ.ค",
          "มิ.ย",
          "ก.ค",
          "ส.ค",
          "ก.ย",
          "ต.ค",
          "พ.ย",
          "ธ.ค"
        ],
        // months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        pickers: ["next 1 days", "previous 1 days"],
        placeholder: {
          date: "Select Date",
          dateRange: "Select Date Range"
        },
        MyScanDate: this.MyScanDate,
        MyHn: this.MyHn,
        MyScanType: this.MyScanType
      },
      FilesScanDataLoad: [],
      tbTableData: null,
      tbTableFieldsData: null,
      sortBy: "numbers",
      sortDesc: true
    };
  },
  mounted() {},
  created() {
    this.thaiDatetimeFc = thaiDatetime.methods;
    this.pjFunctionsFc = pjFunctions.methods;
  },
  watch: {
    MySearchStatus: function() {
      if (this.MySearchStatus == true) {
        this.loadFilesScanDatas(this.MyScanDate, this.MyHn, this.MyScanType);
      }
    }
  },
  methods: {
    show(group, type = "", title = "", text = "") {
      this.$notify({
        group,
        title: title,
        text: text,
        type,
        data: {
          randomNumber: Math.random()
        }
      });
    },
    clean(group) {
      this.$notify({ group, clean: true });
    },
    loadFilesScanDatas(ScanDate, Hn, ScanType) {
      store.set("systems@SpinnersShow", true);

      this.FilesScanDataLoad = [];

      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "FilesScanData", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          scan_date: ScanDate,
          hn: Hn,
          files_type: ScanType
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            ScrObj.FilesScanDataLoad = ScrObj.output.result;
          } else {
            ScrObj.FilesScanDataLoad = [];
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("FilesScanData : " + ScrObj.output);
        })
        .finally(function() {
          store.set("systems@SpinnersShow", false);
          ScrObj.getFilesScanDatasTable();
        });
    },
    getFilesScanDatasTable() {
      let TableData = [];

      let i = 0;

      for (var val of this.FilesScanDataLoad) {
        i = i + 1;
        TableData.push({
          numbers: i,
          scanDatetime: this.thaiDatetimeFc.ThaiDateTime(
            val.scan_opd_card_datetime
          ),
          hn: val.hn,
          fullName: val.pname + val.fname + " " + val.lname,
          birthday: this.thaiDatetimeFc.ThaiDate(val.birthday),
          scan_opd_card_type: val.scan_opd_card_type,
          scan_opd_card_type_name: val.scan_opd_card_type_name,
          scan_opd_card_file_size: val.scan_opd_card_file_size,
          viewFiles: val.scan_file_delete_status,
          deleteFiles: val.scan_file_delete_status,
          scan_file_delete_user: val.scan_file_delete_user,
          scan_file_delete_datetime: val.scan_file_delete_datetime,
          scan_opd_card_datetime: val.scan_opd_card_datetime,
          scan_opd_card_file_name: val.scan_opd_card_file_name,
          scan_file_delete_forever_status: val.scan_file_delete_forever_status,
          scan_file_delete_forever_datetime:
            val.scan_file_delete_forever_datetime
        });
      }

      // console.log("vvv", TableData);

      let TableFieldsData = [
        { label: "ลำดับ", key: "numbers", sortable: true, class: "text-right" },
        {
          label: "Scan DateTime",
          key: "scanDatetime",
          sortable: true
        },
        { label: "HN", key: "hn", sortable: true },
        { label: "ชื่อ-สกุล", key: "fullName", sortable: true },
        { label: "วันเกิด", key: "birthday", sortable: true },
        { label: "Type ID", key: "scan_opd_card_type", sortable: true },
        { label: "Type Name", key: "scan_opd_card_type_name", sortable: true },
        {
          label: "File Size",
          key: "scan_opd_card_file_size",
          sortable: true,
          class: "text-right"
        },
        {
          label: "View File",
          key: "viewFiles",
          sortable: true,
          class: "text-center"
        },
        {
          label: "Delete",
          key: "deleteFiles",
          sortable: true,
          class: "text-center"
        }
      ];

      if (this.FilesScanDataLoad.length > 0) {
        this.tbTableData = TableData;
        this.tbTableFieldsData = TableFieldsData;
      } else {
        this.tbTableData = null;
        this.tbTableFieldsData = null;
      }
    },
    viewDocScans(
      hn,
      scan_opd_card_type,
      scan_opd_card_datetime,
      scan_opd_card_file_name
    ) {
      let UrlApi = this.$store.get("systems@UrlApi");

      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "DocumentScanView", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          scan_opd_card_type: scan_opd_card_type,
          scan_opd_card_datetime: scan_opd_card_datetime,
          scan_opd_card_file_name: scan_opd_card_file_name,
          scan_opd_card_view_on_host: this.$store.get("systems@UrlApi"),
          scan_opd_card_view_on_software: "PjHIS"
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            let pdf =
              UrlApi +
              "charge_scan_view/" +
              ScrObj.output.result.documentScanFullPaths;

            window.open(pdf);
          } else {
            console.log("DocumentScanView : " + ScrObj.output.ErrorMessage);
          }
        })
        .catch(function(error) {
          ScrObj.output = error;
          console.log("DocumentScanView : " + ScrObj.output);
        })
        .finally(function() {
          ScrObj.DataCh = "DocumentScanView" + scan_opd_card_file_name;
        });
    },

    DeleteFilesScanConfirm(
      txcf,
      hn,
      scan_datetime,
      files_type,
      scan_file_name,
      scan_file_action
    ) {
      this.conF = "";
      this.$bvModal
        .msgBoxConfirm(txcf, {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          this.conF = value;
          if (this.conF == true) {
            this.submitDeleteFilesScan(
              txcf,
              hn,
              scan_datetime,
              files_type,
              scan_file_name,
              scan_file_action
            );
          }
        })
        .catch(err => {
          // An error occurred
        });
    },
    submitDeleteFilesScan(
      txcf,
      hn,
      scan_datetime,
      files_type,
      scan_file_name,
      scan_file_action
    ) {
      let ScrObj = this;
      this.axios
        .post(this.$store.get("systems@UrlApi") + "FilesScanDataAction", {
          CompanyId: this.$store.get("systems@CompanyId"),
          ApiKey: this.$store.get("systems@ApiKey"),
          hn: hn,
          scan_datetime: scan_datetime,
          files_type: files_type,
          scan_file_name: scan_file_name,
          scan_file_action: scan_file_action
        })
        .then(function(response) {
          ScrObj.output = response.data;
          if (ScrObj.output.status === true) {
            ScrObj.show(
              "notifi-main-top-right",
              "success",
              "Save Data Success",
              "การบันทึกข้อมูลเสร็จสมบูรณ์ ^_^ <br>Date : " +
                ScrObj.thaiDatetimeFc.ThaiDateTime(
                  ScrObj.thaiDatetimeFc.DateTimeNow()
                )
            );
          } else {
            ScrObj.show(
              "notifi-main-top-right",
              "warn",
              "Save Data Error",
              "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
                "<br>ErrorMessage : " +
                ScrObj.output.ErrorMessage +
                "<br>Date : " +
                ScrObj.thaiDatetimeFc.ThaiDateTime(
                  ScrObj.thaiDatetimeFc.DateTimeNow()
                )
            );
          }
        })
        .catch(function(error) {
          ScrObj.output = error;

          ScrObj.show(
            "er-opd-pgn-foo-css",
            "error",
            "Save Data Error",
            "การบันทึกข้อมูลมีปัญหากรุณาลองใหม่อีกครั้ง ^_^ " +
              "<br>ErrorMessage : " +
              ScrObj.output +
              "<br>Date : " +
              ScrObj.thaiDatetimeFc.ThaiDateTime(
                ScrObj.thaiDatetimeFc.DateTimeNow()
              )
          );

          console.log("FilesScanDataAction : " + ScrObj.output);
        })
        .finally(function() {
          ScrObj.loadFilesScanDatas(
            ScrObj.MyScanDate,
            ScrObj.MyHn,
            ScrObj.MyScanType
          );
        });
    }
  }
})
export default class FilesScanDatas extends Vue {}
</script>


<style lang="scss">
</style>
